import React, {useState} from "react";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";

const EmailAddressDialog = ({open, handleCancel, handleSubmit}) => {
    const [emailAddress, setEmailAddress] = useState("");

    return (
        <Dialog open={open} onClose={handleCancel} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Submit Report Generation Request</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Due to parameters selected, this report will take time to generate. Enter your email address, and
                    a download link to retrieve the report will be sent to you upon completion.
                </DialogContentText>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Email Address"
                    type="email"
                    value={emailAddress}
                    onChange={event => setEmailAddress(event.currentTarget.value)}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => handleSubmit(emailAddress)} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EmailAddressDialog;
